import { Dialog, DialogContent } from "@b2bportal/core-ui";
import { useI18nContext } from "@hopper-b2b/i18n";
import styles from "./PrivacyPolicyModal.module.scss";

interface PrivacyPolicyModalProps {
  open: boolean;
  onClose: () => void;
}

export const PrivacyPolicyModal = ({
  open,
  onClose,
}: PrivacyPolicyModalProps) => {
  const { t } = useI18nContext();

  return (
    <Dialog open={open} onOpenChange={onClose} modal={true}>
      <DialogContent
        showCloseButton={true}
        title={t("footer.privacyPolicy")}
        className={styles.privacyPolicyContent}
      >
        <div
          className={styles.privacyPolicyText}
          dangerouslySetInnerHTML={{ __html: t("footer.privacyPolicyContent") }}
        />
      </DialogContent>
    </Dialog>
  );
};
